// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as Svg from "../../primitives/Svg.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Badge from "../../resources/feedback-indicators/Badge.res.js";
import * as Hover from "../../primitives/Hover.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as React from "react";
import * as Tooltip from "../../resources/overlays/Tooltip.res.js";
import * as Pastille from "../../resources/feedback-indicators/Pastille.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as CatalogProduct from "../Catalog/CatalogProduct.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
let styles = {
  root: {
    "cursor-kkrTdU": "cursor-x1sqbtui",
    "display-k1xSpc": "display-x78zum5",
    "zIndex-kY2c9j": "zIndex-x1vjfegm",
    $$css: "wino-gc:src/modules/Product/ProductReferenceTableCell.res.js:21"
  }
};
function styleProps() {
  return {
    className: "cursor-x1sqbtui display-x78zum5 zIndex-x1vjfegm",
    "data-style-src": "wino-gc:src/modules/Product/ProductReferenceTableCell.res.js:21"
  };
}
function ProductReferenceTableCell$TooltipIconTrigger(props) {
  let information = props.information;
  let match = React.useState(() => false);
  let setTooltipOpened = match[1];
  let tooltipOpened = match[0];
  let content = JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [JsxRuntime.jsx(Tooltip.Span.make, {
      text: I18n.t("Name") + I18n.t(":") + " ",
      tone: "faded"
    }), JsxRuntime.jsx(Tooltip.Span.make, {
      text: information.productName + " | " + information.variantName
    }), JsxRuntime.jsx(Tooltip.Gap.make, {
      space: "xxsmall"
    }), Stdlib_Option.mapOr(information.sku, null, sku => JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [JsxRuntime.jsx(Tooltip.Span.make, {
        text: I18n.t("SKU code") + I18n.t(":") + " ",
        tone: "faded"
      }), JsxRuntime.jsx(Tooltip.Span.make, {
        text: sku
      }), JsxRuntime.jsx(Tooltip.Gap.make, {
        space: "xxsmall"
      })]
    })), Stdlib_Option.mapOr(information.plu, null, plu => JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [JsxRuntime.jsx(Tooltip.Span.make, {
        text: I18n.t("PLU code") + I18n.t(":") + " ",
        tone: "faded"
      }), JsxRuntime.jsx(Tooltip.Span.make, {
        text: plu
      }), JsxRuntime.jsx(Tooltip.Gap.make, {
        space: "xxsmall"
      })]
    })), Stdlib_Option.mapOr(information.internalCode, null, internalCode => JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [JsxRuntime.jsx(Tooltip.Span.make, {
        text: I18n.t("Internal code") + I18n.t(":") + " ",
        tone: "faded"
      }), JsxRuntime.jsx(Tooltip.Span.make, {
        text: internalCode
      }), JsxRuntime.jsx(Tooltip.Gap.make, {
        space: "xxsmall"
      })]
    })), JsxRuntime.jsx(Tooltip.Gap.make, {
      space: "small"
    }), Stdlib_Option.mapOr(information.color, null, color => JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [JsxRuntime.jsx(Tooltip.Span.make, {
        text: I18n.t("Color") + I18n.t(":") + " ",
        tone: "faded"
      }), JsxRuntime.jsx(Tooltip.Span.make, {
        text: CatalogProduct.Color.toLabel(color)
      }), JsxRuntime.jsx(Tooltip.Gap.make, {
        space: "xxsmall"
      })]
    })), Stdlib_Option.mapOr(information.producerName, null, producer => JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [JsxRuntime.jsx(Tooltip.Span.make, {
        text: I18n.t("Producer") + I18n.t(":") + " ",
        tone: "faded"
      }), JsxRuntime.jsx(Tooltip.Span.make, {
        text: producer
      }), JsxRuntime.jsx(Tooltip.Gap.make, {
        space: "xxsmall"
      })]
    })), Stdlib_Option.mapOr(information.supplierName, null, supplier => JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [JsxRuntime.jsx(Tooltip.Span.make, {
        text: I18n.t("Supplier") + I18n.t(":") + " ",
        tone: "faded"
      }), JsxRuntime.jsx(Tooltip.Span.make, {
        text: supplier
      }), JsxRuntime.jsx(Tooltip.Gap.make, {
        space: "xxsmall"
      })]
    })), Stdlib_Option.mapOr(information.designation, null, designation => JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [JsxRuntime.jsx(Tooltip.Span.make, {
        text: I18n.t("Designation") + I18n.t(":") + " ",
        tone: "faded"
      }), JsxRuntime.jsx(Tooltip.Span.make, {
        text: designation
      }), JsxRuntime.jsx(Tooltip.Gap.make, {
        space: "xxsmall"
      })]
    })), Stdlib_Option.mapOr(information.productFamily, null, productFamily => JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [JsxRuntime.jsx(Tooltip.Span.make, {
        text: I18n.t("Family") + I18n.t(":") + " ",
        tone: "faded"
      }), JsxRuntime.jsx(Tooltip.Span.make, {
        text: productFamily
      }), JsxRuntime.jsx(Tooltip.Gap.make, {
        space: "xxsmall"
      })]
    })), Stdlib_Option.mapOr(information.beerType, null, beerType => JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [JsxRuntime.jsx(Tooltip.Span.make, {
        text: I18n.t("Beer type") + I18n.t(":") + " ",
        tone: "faded"
      }), JsxRuntime.jsx(Tooltip.Span.make, {
        text: beerType
      }), JsxRuntime.jsx(Tooltip.Gap.make, {
        space: "xxsmall"
      })]
    })), Stdlib_Option.mapOr(information.wineType, null, wineType => JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [JsxRuntime.jsx(Tooltip.Span.make, {
        text: I18n.t("Wine type") + I18n.t(":") + " ",
        tone: "faded"
      }), JsxRuntime.jsx(Tooltip.Span.make, {
        text: CatalogProduct.WineType.toLabel(wineType)
      }), JsxRuntime.jsx(Tooltip.Gap.make, {
        space: "xxsmall"
      })]
    })), Stdlib_Option.mapOr(information.whiteWineType, null, whiteWineType => JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [JsxRuntime.jsx(Tooltip.Span.make, {
        text: I18n.t("White wine type") + I18n.t(":") + " ",
        tone: "faded"
      }), JsxRuntime.jsx(Tooltip.Span.make, {
        text: CatalogProduct.WhiteWineType.toLabel(whiteWineType)
      }), JsxRuntime.jsx(Tooltip.Gap.make, {
        space: "xxsmall"
      })]
    })), Stdlib_Option.mapOr(information.region, null, region => {
      let formattedRegion = region + ", " + information.country;
      return JsxRuntime.jsxs(JsxRuntime.Fragment, {
        children: [JsxRuntime.jsx(Tooltip.Span.make, {
          text: I18n.t("Region") + I18n.t(":") + " ",
          tone: "faded"
        }), JsxRuntime.jsx(Tooltip.Span.make, {
          text: formattedRegion
        }), JsxRuntime.jsx(Tooltip.Gap.make, {
          space: "xxsmall"
        })]
      });
    }), JsxRuntime.jsx(Tooltip.Span.make, {
      text: I18n.t("Category") + I18n.t(":") + " ",
      tone: "faded"
    }), JsxRuntime.jsx(Tooltip.Span.make, {
      text: information.categoryName
    }), JsxRuntime.jsx(Tooltip.Gap.make, {
      space: "xxsmall"
    }), Stdlib_Option.mapOr(information.alcoholVolume, null, alcoholVolume => JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [JsxRuntime.jsx(Tooltip.Span.make, {
        text: I18n.t("Alcohol volume") + I18n.t(":") + " ",
        tone: "faded"
      }), JsxRuntime.jsx(Tooltip.Span.make, {
        text: alcoholVolume
      }), JsxRuntime.jsx(Tooltip.Gap.make, {
        space: "xxsmall"
      })]
    }))]
  });
  let match$1 = {
    className: "cursor-x1sqbtui display-x78zum5 zIndex-x1vjfegm",
    "data-style-src": "wino-gc:src/modules/Product/ProductReferenceTableCell.res.js:21"
  };
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx(Tooltip.make, {
      children: JsxRuntime.jsxs(Svg.make, {
        children: [JsxRuntime.jsx(Svg.Path.make, {
          d: "M6 11.2A5.2 5.2 0 1 0 .8 6v4.2a1 1 0 0 0 1 1H6z",
          fill: tooltipOpened ? "#25243A" : "transparent",
          transform: "translate(0, 1)"
        }), JsxRuntime.jsx(Svg.Path.make, {
          d: tooltipOpened ? "M6.99997 10C7.27611 10 7.49997 9.77614 7.49997 9.5L7.49998 7.49998L9.5 7.5C9.77614 7.5 10 7.27614 10 7C10 6.72386 9.77614 6.5 9.5 6.5L7.49999 6.5L7.50001 4.5C7.50001 4.22386 7.27615 4 7.00001 4C6.72387 4 6.50001 4.22386 6.50001 4.5L6.50001 6.5L4.5 6.5C4.22386 6.5 4 6.72382 4 6.99996C4 7.2761 4.22386 7.49996 4.5 7.49996L6.50001 7.49998L6.50001 9.5C6.50001 9.77614 6.72383 10 6.99997 10Z" : "M6.99997 11C7.27611 11 7.49997 10.7761 7.49997 10.5L7.49999 7.49998L10.5 7.5C10.7761 7.5 11 7.27614 11 7C11 6.72386 10.7761 6.5 10.5 6.5L7.49999 6.5L7.50001 3.5C7.50001 3.22386 7.27615 3 7.00001 3C6.72387 3 6.50001 3.22386 6.50001 3.5L6.50001 6.5L3.5 6.5C3.22386 6.5 3 6.72382 3 6.99996C3 7.2761 3.22386 7.49996 3.5 7.49996L6.50001 7.49998L6.50001 10.5C6.50001 10.7761 6.72383 11 6.99997 11Z",
          fill: tooltipOpened ? "#FFF" : "#A2A1B0",
          transform: "translate(-1, 0)"
        })],
        width: "20",
        height: "14",
        viewBox: "0 0 14 14",
        style: {
          height: "100%"
        }
      }),
      arrowed: false,
      placement: "bottom start",
      offset: 0,
      crossOffset: 2,
      content: content,
      delay: 125,
      closeDelay: 50,
      onOpenChange: opened => setTooltipOpened(param => opened)
    }),
    className: match$1.className,
    style: match$1.style
  });
}
let TooltipIconTrigger = {
  styles: styles,
  styleProps: styleProps,
  make: ProductReferenceTableCell$TooltipIconTrigger
};
let styles$1 = {
  root: {
    "pointerEvents-kfzvcC": "pointerEvents-x47corl",
    "alignItems-kGNEyG": "alignItems-x6s0dn4",
    "display-k1xSpc": "display-x78zum5",
    "height-kZKoxP": "height-x1gnnpzl",
    "justifyContent-kjj79g": "justifyContent-xl56j7k",
    "margin-kogj98": "margin-x1ixu4ct",
    "position-kVAEAm": "position-x10l6tqk",
    "right-kCIrl2": "right-x3m8u43",
    "width-kzqmXN": "width-x1kl0l3y",
    $$css: "wino-gc:src/modules/Product/ProductReferenceTableCell.res.js:293"
  }
};
function styleProps$1(hovered) {
  return Stylex.props(styles$1.root, {
    backgroundColor: hovered ? "#f3f3f7" : "transparent",
    opacity: hovered ? 1 : 0,
    transition: "width .15s ease, opacity .15s ease, backgroundColor .05s ease, boxShadow .05s ease",
    boxShadow: (hovered ? "#f3f3f7" : "transparent") + ` -8px 0 13px 10px`,
    width: hovered ? "21px" : "0px"
  });
}
function ProductReferenceTableCell$PressableIconIndicator(props) {
  let match = styleProps$1(props.hovered);
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx(Svg.make, {
      children: JsxRuntime.jsx(Svg.Path.make, {
        d: "M 11.236 4.018 L 16.683 9.464 L 1.97 9.464 C 1.559 9.464 1.301 9.91 1.508 10.267 C 1.603 10.433 1.779 10.535 1.97 10.535 L 16.799 10.535 L 11.352 15.981 C 11.06 16.272 11.194 16.768 11.592 16.876 C 11.775 16.926 11.973 16.873 12.108 16.738 L 18.408 10.436 C 18.618 10.227 18.618 9.887 18.408 9.679 L 11.991 3.263 C 11.784 3.053 11.444 3.053 11.236 3.263 C 11.027 3.47 11.027 3.81 11.236 4.018 Z",
        fill: "#25243A"
      }),
      width: "14",
      height: "16",
      viewBox: "0 0 20 20"
    }),
    className: match.className,
    style: match.style
  });
}
let PressableIconIndicator = {
  styles: styles$1,
  styleProps: styleProps$1,
  make: ProductReferenceTableCell$PressableIconIndicator
};
let styles$2 = {
  root: {
    "cursor-kkrTdU": "cursor-x1ypdohk",
    "alignItems-kGNEyG": "alignItems-x6s0dn4",
    "display-k1xSpc": "display-x78zum5",
    "gap-kOIVth": "gap-x1jnr06f",
    "height-kZKoxP": "height-x1gnnpzl",
    "position-kVAEAm": "position-x1n2onr6",
    "width-kzqmXN": "width-xh8yej3",
    $$css: "wino-gc:src/modules/Product/ProductReferenceTableCell.res.js:342"
  },
  pastille: {
    "alignSelf-kSGwAc": "alignSelf-xqcrz7y",
    "minWidth-k7Eaqz": "minWidth-x11inojt",
    "paddingTop-kLKAdn": "paddingTop-x1iorvi4",
    $$css: "wino-gc:src/modules/Product/ProductReferenceTableCell.res.js:351"
  },
  separator: {
    "backgroundColor-kWkggS": "backgroundColor-xwn4flb",
    "height-kZKoxP": "height-xx3o462",
    "margin-kogj98": "margin-xmtjor9",
    "minWidth-k7Eaqz": "minWidth-x9041oi",
    $$css: "wino-gc:src/modules/Product/ProductReferenceTableCell.res.js:356"
  },
  primaryTextProductName: {
    "color-kMwMTN": "color-xbp64b2",
    "font-kVVagm": "font-x1mfpbqu",
    "lineHeight-kLWn49": "lineHeight-x1d3mw78",
    "textOverflow-kg5iWk": "textOverflow-xlyipyv",
    "whiteSpace-khDVqt": "whiteSpace-xuxw1ft",
    "flex-kUk6DE": "flex-x98rzlu",
    "maxWidth-ks0D6T": "maxWidth-x1u4bug8",
    "minWidth-k7Eaqz": "minWidth-xt4ypqs",
    "overflow-kVQacm": "overflow-xb3r6kr",
    $$css: "wino-gc:src/modules/Product/ProductReferenceTableCell.res.js:362"
  },
  primaryTextVariantName: {
    "color-kMwMTN": "color-xbp64b2",
    "font-kVVagm": "font-x1mfpbqu",
    "lineHeight-kLWn49": "lineHeight-x1d3mw78",
    "textOverflow-kg5iWk": "textOverflow-xlyipyv",
    "whiteSpace-khDVqt": "whiteSpace-xuxw1ft",
    "overflow-kVQacm": "overflow-xb3r6kr",
    $$css: "wino-gc:src/modules/Product/ProductReferenceTableCell.res.js:373"
  },
  primaryTextDisabled: {
    "color-kMwMTN": "color-x1qqs05d",
    "fontWeight-k63SB2": "fontWeight-xo1l8bm",
    "transform-k3aq6I": "transform-x1d3dgck",
    $$css: "wino-gc:src/modules/Product/ProductReferenceTableCell.res.js:381"
  },
  secondaryTextDescription: {
    "color-kMwMTN": "color-x1qqs05d",
    "font-kVVagm": "font-xyj1cuj",
    "lineHeight-kLWn49": "lineHeight-x1wfe3co",
    "textOverflow-kg5iWk": "textOverflow-xlyipyv",
    "whiteSpace-khDVqt": "whiteSpace-xuxw1ft",
    "overflow-kVQacm": "overflow-xb3r6kr",
    $$css: "wino-gc:src/modules/Product/ProductReferenceTableCell.res.js:386"
  }
};
function styleProps$2(disabled) {
  return {
    0: {
      className: "cursor-x1ypdohk alignItems-x6s0dn4 display-x78zum5 gap-x1jnr06f height-x1gnnpzl position-x1n2onr6 width-xh8yej3",
      "data-style-src": "wino-gc:src/modules/Product/ProductReferenceTableCell.res.js:342"
    },
    1: {
      className: "cursor-x1ypdohk alignItems-x6s0dn4 display-x78zum5 gap-x1jnr06f height-x1gnnpzl position-x1n2onr6 width-xh8yej3",
      style: {
        cursor: "auto"
      },
      "data-style-src": "wino-gc:src/modules/Product/ProductReferenceTableCell.res.js:342"
    }
  }[!!disabled << 0];
}
function pastilleStyleProps() {
  return {
    className: "alignSelf-xqcrz7y minWidth-x11inojt paddingTop-x1iorvi4",
    "data-style-src": "wino-gc:src/modules/Product/ProductReferenceTableCell.res.js:351"
  };
}
function productNameStyleProps(disabled) {
  return {
    0: {
      className: "color-xbp64b2 font-x1mfpbqu lineHeight-x1d3mw78 textOverflow-xlyipyv whiteSpace-xuxw1ft flex-x98rzlu maxWidth-x1u4bug8 minWidth-xt4ypqs overflow-xb3r6kr",
      "data-style-src": "wino-gc:src/modules/Product/ProductReferenceTableCell.res.js:362"
    },
    1: {
      className: "font-x1mfpbqu lineHeight-x1d3mw78 textOverflow-xlyipyv whiteSpace-xuxw1ft flex-x98rzlu maxWidth-x1u4bug8 minWidth-xt4ypqs overflow-xb3r6kr color-x1qqs05d fontWeight-xo1l8bm transform-x1d3dgck",
      "data-style-src": "wino-gc:src/modules/Product/ProductReferenceTableCell.res.js:362; wino-gc:src/modules/Product/ProductReferenceTableCell.res.js:381"
    }
  }[!!disabled << 0];
}
function variantNameStyleProps(disabled) {
  return {
    0: {
      className: "color-xbp64b2 font-x1mfpbqu lineHeight-x1d3mw78 textOverflow-xlyipyv whiteSpace-xuxw1ft overflow-xb3r6kr",
      "data-style-src": "wino-gc:src/modules/Product/ProductReferenceTableCell.res.js:373"
    },
    1: {
      className: "font-x1mfpbqu lineHeight-x1d3mw78 textOverflow-xlyipyv whiteSpace-xuxw1ft overflow-xb3r6kr color-x1qqs05d fontWeight-xo1l8bm transform-x1d3dgck",
      "data-style-src": "wino-gc:src/modules/Product/ProductReferenceTableCell.res.js:373; wino-gc:src/modules/Product/ProductReferenceTableCell.res.js:381"
    }
  }[!!disabled << 0];
}
function descriptionNameStyleProps() {
  return {
    className: "color-x1qqs05d font-xyj1cuj lineHeight-x1wfe3co textOverflow-xlyipyv whiteSpace-xuxw1ft overflow-xb3r6kr",
    "data-style-src": "wino-gc:src/modules/Product/ProductReferenceTableCell.res.js:386"
  };
}
function separatorStyleProps(disabled) {
  return {
    0: {
      className: "backgroundColor-xwn4flb height-xx3o462 margin-xmtjor9 minWidth-x9041oi",
      "data-style-src": "wino-gc:src/modules/Product/ProductReferenceTableCell.res.js:356"
    },
    1: {
      className: "backgroundColor-xwn4flb height-xx3o462 margin-xmtjor9 minWidth-x9041oi",
      style: {
        opacity: 0.7,
        transform: "skewX(-12deg)",
        marginRight: "6px"
      },
      "data-style-src": "wino-gc:src/modules/Product/ProductReferenceTableCell.res.js:356"
    }
  }[!!disabled << 0];
}
function ProductReferenceTableCell(props) {
  let __hideProducerAndSupplier = props.hideProducerAndSupplier;
  let information = props.information;
  let errorMessage = props.errorMessage;
  let __disabled = props.disabled;
  let badge = props.badge;
  let redirectRoute = props.redirectRoute;
  let disabled = __disabled !== undefined ? __disabled : false;
  let hideProducerAndSupplier = __hideProducerAndSupplier !== undefined ? __hideProducerAndSupplier : false;
  let match = Hover.use(undefined, undefined, undefined);
  let match$1 = styleProps$2(disabled);
  let match$2 = {
    className: "alignSelf-xqcrz7y minWidth-x11inojt paddingTop-x1iorvi4",
    "data-style-src": "wino-gc:src/modules/Product/ProductReferenceTableCell.res.js:351"
  };
  let match$3 = separatorStyleProps(disabled);
  let match$4 = productNameStyleProps(disabled);
  let match$5 = variantNameStyleProps(disabled);
  let match$6 = {
    className: "color-x1qqs05d font-xyj1cuj lineHeight-x1wfe3co textOverflow-xlyipyv whiteSpace-xuxw1ft overflow-xb3r6kr",
    "data-style-src": "wino-gc:src/modules/Product/ProductReferenceTableCell.res.js:386"
  };
  let to = Stdlib_Option.mapOr(redirectRoute, {
    TAG: "Route",
    _0: ""
  }, route => ({
    TAG: "Route",
    _0: route
  }));
  let formattedDescription = CatalogProduct.Information.formatDescription(props.productKind, information, true, hideProducerAndSupplier, hideProducerAndSupplier, undefined);
  let pastilleColor = Stdlib_Option.map(information.color, color => CatalogProduct.Color.toColorSet(color, "pastille").foregroundColor);
  let newrecord = {
    ...{
      style: {
        display: "contents"
      }
    }
  };
  newrecord.ref = Primitive_option.some(match[0]);
  let newrecord$1 = {
    ...{
      style: {
        alignItems: "center",
        display: "flex",
        paddingRight: "32px"
      }
    }
  };
  let newrecord$2 = {
    ...{
      style: {
        alignItems: "center",
        display: "flex",
        paddingRight: "32px"
      }
    }
  };
  newrecord.children = JsxRuntime.jsxs(Navigation.Link.make, {
    children: [JsxRuntime.jsx("div", {
      children: JsxRuntime.jsx(Pastille.make, {
        color: pastilleColor
      }),
      className: match$2.className,
      style: match$2.style
    }), JsxRuntime.jsxs(Stack.make, {
      children: [JsxRuntime.jsxs("div", (newrecord$1.children = [JsxRuntime.jsx("span", {
        children: information.productName,
        className: match$4.className,
        style: match$4.style,
        title: information.productName
      }), JsxRuntime.jsx("div", {
        className: match$3.className,
        style: match$3.style
      }), JsxRuntime.jsx("span", {
        children: information.variantName,
        className: match$5.className,
        style: match$5.style
      }), badge !== undefined && !disabled ? JsxRuntime.jsx(Box.make, {
        children: JsxRuntime.jsx(Badge.make, {
          children: badge.text,
          size: "small",
          variation: badge.variation
        }),
        spaceLeft: "small"
      }) : null], newrecord$1)), JsxRuntime.jsx("div", (newrecord$2.children = errorMessage !== undefined ? JsxRuntime.jsx(TextStyle.make, {
        children: errorMessage,
        variation: "negative",
        size: "tiny",
        lineHeight: "normal"
      }) : JsxRuntime.jsxs(JsxRuntime.Fragment, {
        children: [JsxRuntime.jsx("span", {
          children: formattedDescription,
          className: match$6.className,
          style: match$6.style,
          title: formattedDescription
        }), JsxRuntime.jsx(ProductReferenceTableCell$TooltipIconTrigger, {
          information: information
        })]
      }), newrecord$2))],
      space: "none"
    }), Stdlib_Option.isSome(redirectRoute) ? JsxRuntime.jsx(ProductReferenceTableCell$PressableIconIndicator, {
      hovered: match[1]
    }) : null],
    to: to,
    disabled: Stdlib_Option.isNone(redirectRoute) || disabled,
    className: match$1.className
  });
  return JsxRuntime.jsx("div", newrecord);
}
let make = ProductReferenceTableCell;
export { TooltipIconTrigger, PressableIconIndicator, styles$2 as styles, styleProps$2 as styleProps, pastilleStyleProps, productNameStyleProps, variantNameStyleProps, descriptionNameStyleProps, separatorStyleProps, make };
/* styles Not a pure module */